import type { GameState, HealthStatus } from '../game/types';

export function weeklyCommitments(state: GameState): number {
  const dueBankPrincipal = state.loans
    .filter((loan) => loan.kind === 'bank' && loan.weeksRemaining <= 0)
    .reduce((sum, loan) => sum + loan.principalRemaining, 0);
  const last = state.lastReport;
  if (last) return Math.max(1, last.operatingCosts + last.hubCosts + last.interest + last.principalPaid + dueBankPrincipal);
  const loanPayments = state.loans.reduce((sum, loan) => sum + loan.weeklyPayment, 0);
  const hubCosts = state.hubs.reduce((sum, hub) => sum + hub.weeklyCost, 0);
  return Math.max(1, loanPayments + hubCosts + dueBankPrincipal + 100_000);
}

export function cashRunway(state: GameState): number {
  return Math.max(0, state.cash / weeklyCommitments(state));
}

export function healthStatus(state: GameState): HealthStatus {
  const runway = cashRunway(state);
  const commitments = weeklyCommitments(state);
  if (state.cash < -commitments * 4) return 'restructuring';
  if (state.cash < 0 || runway < 4) return 'crisis';
  if (runway < 8 || (state.lastReport?.operatingProfit ?? 0) < -commitments * 0.2) return 'warning';
  return 'healthy';
}
